module.exports = require('./lib/index');



/** WEBPACK FOOTER **
 ** node_modules/redux/~/symbol-observable/index.js
 **/